export default __webpack_public_path__ + "static/black-logo-bb711faf29ccbee53ac9728e857a94f3.png";